import styled from 'styled-components';
import media from 'styled-media-query';

import { LpInner } from '../../atoms/LpInner';
import { LpTitle } from '../../atoms/LpTitle';
import { AccountSubscriptionLpDealTable } from '../../molecules/accountSubscription/AccountSubscriptionLpDealTable';

export const AccountSubscriptionLpDeal = (): JSX.Element => {
  return (
    <Deal id="deal">
      <DealInner>
        <LpTitle>
          <h2>他スクールとの比較</h2>
          <p>Best Deal</p>
        </LpTitle>
        <TableWrapper>
          <AccountSubscriptionLpDealTable />
        </TableWrapper>
        <Note>
          ※対応可能言語の詳細は
          <a href="https://tayori.com/q/samurai-terakoya/detail/874784/" target="_blank">
            こちら
          </a>
          。
        </Note>
      </DealInner>
    </Deal>
  );
};

const Deal = styled.section`
  padding: 6.25rem 0;
  scroll-margin-top: 49px;

  ${media.lessThan('large')`
    padding-bottom: 4.25rem;
  `}
  ${media.lessThan('medium')`
    padding: 4rem 0 2rem;
    scroll-margin-top: 57px;
  `}
`;
const DealInner = styled(LpInner)`
  ${media.lessThan('large')`
    padding: 0;
  `}
`;
const TableWrapper = styled.div`
  ${media.lessThan('large')`
    margin-top: 3rem;
    padding: 2rem;
    overflow-x: auto;
  `}
  ${media.lessThan('medium')`
    margin-top: 0.5rem;
    padding: 2rem 1rem;
  `}
`;
const Note = styled.p`
  margin-top: 2rem;
  font-size: 0.875rem;
  font-weight: 700;

  a {
    color: #eb0000;
    font-size: 1em;
    text-decoration: underline;
  }

  ${media.lessThan('large')`
    padding: 0 2rem;
  `}

  ${media.lessThan('medium')`
    margin-top: 0;
    padding: 0 1rem;
  `}
`;
